const sortedProfilesAttributes = (profiles) => {
    const sortedProfileAttributes = profiles.map(profile => {
        const sortedKeys = Object.keys(profile.attributes).sort();
        const sortedAttributes = sortedKeys.reduce((acc, key) => {
            acc[key] = profile.attributes[key];
            return acc;
        }, {});
        return {
            ...profile,
            attributes: sortedAttributes
        }
    })
    return sortedProfileAttributes;
};

export default sortedProfilesAttributes;